/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Tim_S3Inputs */

const en_mk_tut_tim_s3 = /** @type {(inputs: Mk_Tut_Tim_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The invitation link also appears on screen, so you can send it over WhatsApp if that reaches them faster.`)
};

const id_mk_tut_tim_s3 = /** @type {(inputs: Mk_Tut_Tim_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tautan undangan juga muncul di layar, jadi Anda bisa mengirimkannya lewat WhatsApp kalau lebih cepat sampai.`)
};

/**
* | output |
* | --- |
* | "The invitation link also appears on screen, so you can send it over WhatsApp if that reaches them faster." |
*
* @param {Mk_Tut_Tim_S3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_tim_s3 = /** @type {((inputs?: Mk_Tut_Tim_S3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Tim_S3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_tim_s3(inputs)
	return en_mk_tut_tim_s3(inputs)
});